import React from 'react';
import PropTypes from 'prop-types';
import ZeroPaymentIcon from './ZeroPaymentIcon';
import styles from './ZeroPaymentBox.module.scss';

const ZeroPaymentBox = ({ copy }) => {
  return (
    <div className={styles.wrapper}>
      <ZeroPaymentIcon />
      <div className={styles.copy}>{ copy }</div>
    </div>
  );
};

ZeroPaymentBox.propTypes = {
  copy: PropTypes.string.isRequired,
};

export default ZeroPaymentBox;
